import { Home, ArrowLeft, Search } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-24 text-center">
      <div className="inline-flex items-center justify-center p-6 bg-primary-100 rounded-full mb-8">
        <Search className="h-16 w-16 text-primary-600" />
      </div>
      <h1 className="text-6xl md:text-8xl font-bold text-gray-900">404</h1>
      <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mt-6">
        Страница не найдена
      </h2>
      <p className="text-xl text-gray-600 mt-6 max-w-2xl mx-auto">
        Возможно, вы перешли по устаревшей ссылке или страница была перемещена.
        Попробуйте вернуться на главную или воспользуйтесь поиском.
      </p>

      <div className="mt-12 flex flex-col sm:flex-row gap-6 justify-center">
        <Link
          to="/"
          className="btn-primary inline-flex items-center justify-center px-8 py-4"
        >
          <Home className="h-5 w-5 mr-3" />
          На главную
        </Link>
        <button
          onClick={() => window.history.back()}
          className="btn-secondary inline-flex items-center justify-center px-8 py-4"
        >
          <ArrowLeft className="h-5 w-5 mr-3" />
          Вернуться назад
        </button>
      </div>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
        <div className="card">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Популярные страницы</h3>
          <ul className="space-y-3">
            <li>
              <Link to="/about" className="text-primary-600 hover:underline">
                О чемпионате
              </Link>
            </li>
            <li>
              <Link to="/registration" className="text-primary-600 hover:underline">
                Регистрация
              </Link>
            </li>
            <li>
              <Link to="/faq" className="text-primary-600 hover:underline">
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/partners" className="text-primary-600 hover:underline">
                Партнёры
              </Link>
            </li>
          </ul>
        </div>
        <div className="card">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Что делать?</h3>
          <ul className="space-y-3">
            <li className="flex items-start">
              <div className="h-2 w-2 rounded-full bg-primary-500 mt-2 mr-3" />
              <span>Проверьте правильность URL-адреса</span>
            </li>
            <li className="flex items-start">
              <div className="h-2 w-2 rounded-full bg-primary-500 mt-2 mr-3" />
              <span>Воспользуйтесь поиском по сайту</span>
            </li>
            <li className="flex items-start">
              <div className="h-2 w-2 rounded-full bg-primary-500 mt-2 mr-3" />
              <span>Перейдите на главную страницу</span>
            </li>
            <li className="flex items-start">
              <div className="h-2 w-2 rounded-full bg-primary-500 mt-2 mr-3" />
              <span>Свяжитесь с поддержкой, если проблема повторяется</span>
            </li>
          </ul>
        </div>
        <div className="card">
          <h3 className="text-xl font-bold text-gray-900 mb-4">Нужна помощь?</h3>
          <p className="text-gray-600 mb-6">
            Если вы не можете найти нужную информацию, напишите нам в MAX-чат поддержки.
          </p>
          <a
            href="https://max.ru/join/K8Jb-740TCVsQW2qnZVqgPpzFv-ObTp-M4rL79d3rq4"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary inline-flex items-center justify-center w-full"
          >
            Перейти в чат
          </a>
        </div>
      </div>
    </div>
  );
}